import { cnpj, cpf } from 'cpf-cnpj-validator';

export const formatDocument = (document: string): string => {
  return cpf.isValid(document) ? cpf.format(document) : cnpj.format(document);
};
